// buttons on the sidebar & widget
import React from 'react';
import './NavItem.css';

const NavItem = ({ icon, text, active, onClick }) => {
  return (
    <div
      className={`nav-item ${active ? 'active' : 'inactive'}`}
      onClick={onClick}
    >
      {icon}
      <span className="nav-item-text">{text}</span>
    </div>
  );
};

export default NavItem;
